/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a US gallon the same as a UK gallon?`)
};

const es_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Un galón estadounidense es igual a un galón del Reino Unido?`)
};

const de_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist eine US-Gallone dasselbe wie eine UK-Gallone?`)
};

const nl_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een Amerikaanse gallon hetzelfde als een Britse gallon?`)
};

const fr_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un gallon américain est-il le même qu'un gallon britannique ?`)
};

const it_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un gallone USA è lo stesso di un gallone britannico?`)
};

const pt_br2_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um galão US é o mesmo que um galão UK?`)
};

const pt_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um galão americano é o mesmo que um galão britânico?`)
};

const ja_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米国ガロンは英国ガロンと同じですか?`)
};

const zh_uc_vol_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq1_q", locale)
	if (locale === "en") return en_uc_vol_faq1_q(inputs)
	if (locale === "es") return es_uc_vol_faq1_q(inputs)
	if (locale === "de") return de_uc_vol_faq1_q(inputs)
	if (locale === "nl") return nl_uc_vol_faq1_q(inputs)
	if (locale === "fr") return fr_uc_vol_faq1_q(inputs)
	if (locale === "it") return it_uc_vol_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq1_q(inputs)
	if (locale === "pt") return pt_uc_vol_faq1_q(inputs)
	if (locale === "ja") return ja_uc_vol_faq1_q(inputs)
	return zh_uc_vol_faq1_q(inputs)
};